
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import WhatWeDoSection from '../components/sections/WhatWeDoSection';
import WhatWeOfferSection from '../components/sections/WhatWeOfferSection';
import AboutUsSection from '../components/sections/AboutUsSection';
import ContactCTASection from '../components/sections/ContactCTASection';
import AcquisitionFocusSection from '../components/sections/AcquisitionFocusSection';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Index: React.FC = () => {
  const { language } = useLanguage();
  
  return (
    <div className="min-h-screen bg-noa-antiflash-white">
      <Navbar />
      
      <main>
        <HeroSection />
        <WhatWeDoSection />
        <AcquisitionFocusSection />
        
        {/* Operating Platform Highlight Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
            <div className="bg-noa-rich-black rounded-lg p-8 md:p-12">
              <div className="flex flex-col md:flex-row gap-8 justify-between items-center">
                <div className="md:max-w-xl">
                  <h2 className="font-space-grotesk text-3xl md:text-4xl font-bold text-white mb-4">
                    Noa Operating Platform
                  </h2>
                  <p className="text-white/80 text-lg mb-6">
                    Discover how our comprehensive platform accelerates growth and preserves margins across our portfolio companies.
                  </p>
                  <Link to="/operating-platform">
                    <Button className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-lg flex items-center gap-2">
                      Learn More
                      <ArrowRight className="h-5 w-5" />
                    </Button>
                  </Link>
                </div>
                <div className="hidden md:block w-64 h-64 bg-blue-500/20 rounded-full relative overflow-hidden">
                  <div className="absolute w-48 h-48 bg-blue-600/30 rounded-full -bottom-10 -right-10"></div>
                  <div className="absolute w-32 h-32 bg-blue-400/30 rounded-full top-8 left-6"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <WhatWeOfferSection />
        <AboutUsSection />
        <ContactCTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
